/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Mailbox
 */
export interface Mailbox {
    /**
     * 
     * @type {number}
     * @memberof Mailbox
     */
    mailboxNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof Mailbox
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Mailbox
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof Mailbox
     */
    courierId?: number;
}

/**
 * Check if a given object implements the Mailbox interface.
 */
export function instanceOfMailbox(value: object): value is Mailbox {
    return true;
}

export function MailboxFromJSON(json: any): Mailbox {
    return MailboxFromJSONTyped(json, false);
}

export function MailboxFromJSONTyped(json: any, ignoreDiscriminator: boolean): Mailbox {
    if (json == null) {
        return json;
    }
    return {
        
        'mailboxNumber': json['mailboxNumber'] == null ? undefined : json['mailboxNumber'],
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function MailboxToJSON(json: any): Mailbox {
    return MailboxToJSONTyped(json, false);
}

export function MailboxToJSONTyped(value?: Mailbox | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mailboxNumber': value['mailboxNumber'],
        'id': value['id'],
        'userId': value['userId'],
        'courierId': value['courierId'],
    };
}

